import { injectable } from 'inversify';
import 'reflect-metadata';

import { IBagApi } from '@@/bags/ts';
import { CrudService, ICrudService } from '@@/common/services/crud.service';
import { CrudMeta } from '@@/common/decorators/crud-meta.decorator';

@injectable()
@CrudMeta({
  modelName: 'bag',
  tableName: 'bag',
})
export class BagsService extends CrudService<IBagApi> implements IBagsService {}

export interface IBagsService extends ICrudService<IBagApi> {}
